var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-content"},[_c('img',{attrs:{"src":require("@/assets/images/mountain.svg"),"alt":"empty"}}),_c('div',[_vm._t("default",function(){return [_c('div',{staticClass:"m-t-24 grey-3"},[_vm._v(_vm._s(_vm.label))])]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }